import { z } from "zod";

const ExportUsersSchema = z.object({
  search: z.string().optional(),
  format: z.enum(["csv", "json"]),
});

export default ExportUsersSchema;
